
import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { IconComponent } from "./icon.component";

@Component({
    selector: 'title-icon',
    imports: [CommonModule, IconComponent],
    template: `
<div class="holder" [ngClass]="{ normal: !small }">
  <icon class="titleIcon" *ngIf="titleIcon" [icon]="titleIcon" [i18]="!small" [i12]="!!small"></icon>
  <h3 *ngIf="!small && !!title" class="title">{{ title }}</h3>
  <div *ngIf="!!small && !!title" class="name">{{ title }}</div>
  <ng-content></ng-content>
</div>`,
    styles: [`
.holder { display: flex; width: fit-content; }
.holder.normal { margin-bottom: 5px; }
.holder icon.titleIcon { height: 18px; min-width: 18px; margin-right: 4px; line-height: 24px; color: #41474f; }
.name { font-size: 11px; color: rgba(0, 0, 0, 0.4); font-weight: bold; text-transform: uppercase; }
 `],
    standalone: true,
})
export class TitleIconComponent {
  @Input() titleIcon
  @Input() title
  @Input() small
}
